import { SecurityZoneListPanel } from '@/components/features/applications/security-zones/SecurityZoneListPanel';
import { isTemperatureZone } from '@/lib/enum-resolvers';

export function TemperatureZonesPanel() {
  return (
    <SecurityZoneListPanel
      title="Temperature"
      description="Monitor temperature zones"
      emptyTitle="No Temperature Zones"
      emptyDescription="No temperature zones are configured on this device."
      emptyIconPath="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 6.51 6.51 0 009 4.5a.75.75 0 01.721.544l1.515 5.063a.956.956 0 001.526.47L15.362 5.214z"
      noZonesTitle="No Temperature Zones"
      noZonesDescription="No temperature zones are active on this device."
      filterFn={isTemperatureZone}
    />
  );
}
